import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  token: "",
  number: "",
  profile: "",
  email: "",
  bookingID: null,
  paymentMethod:""
};

export const TempAuthSlice = createSlice({
  name: "TempAuthSlice",
  initialState,

  reducers: {
    setTempLogin: (state, action) => {
      state.token = action.payload;
    },
    setTempNumber: (state, action) => {
      state.number = action.payload;
    },
    setTempEmail: (state, action) => {
      state.email = action.payload;
    },

    setTempProfileData: (state, action) => {
      state.profile = action.payload;
    },

    setBookingIdForThankYouModal: (state, action) => {
      state.bookingID = action.payload;
    },

    setBookingTypeForThankYouModal: (state, action) => {
      state.paymentMethod = action.payload;
    },

    setTempLogOut: (state, action) => {
      state.number = "";
      state.email = "";
      state.token = "";
      state.profile = "";
      state.bookingID = null;
      state.paymentMethod = "";
    },
  },
});
export const {
  setTempLogin,
  setTempLogOut,
  setBookingIdForThankYouModal,
  setTempEmail,
  setTempNumber,
  setTempProfileData,
  setBookingTypeForThankYouModal
} = TempAuthSlice.actions;
export default TempAuthSlice.reducer;
